import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';

@Component({
    selector: 'cp-purchase-order-summary',
    templateUrl: './purchase-order-summary.component.html',
    styleUrls: ['./purchase-order-summary.component.scss']
})
export class PurchaseOrderSummaryComponent implements OnInit {

    constructor() { }

    @Input() chartType: string;
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    widgetQuery: DashboardQueries = DashboardQueries.purchaseOrderSummary;
    chartSearchFilters: widgetFilters[] = [
        widgetFilters.customer,
        widgetFilters.locations,
        widgetFilters.dateRange,
        widgetFilters.dispatchNbr,
        widgetFilters.supplier,
        widgetFilters.orderNbr,
        widgetFilters.inventoryNbr];

    ngOnInit() {
    }

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }

}
